import { render, staticRenderFns } from "./CommunityHeader.vue?vue&type=template&id=2024e0aa&scoped=true&"
import script from "./CommunityHeader.vue?vue&type=script&lang=js&"
export * from "./CommunityHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHeader.vue?vue&type=style&index=0&id=2024e0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024e0aa",
  null
  
)

export default component.exports